import React, { useState, useRef, useEffect, FC } from "react";
import { GoChevronDown } from "react-icons/go";
import { toast } from "react-toastify";

interface CustomSelectProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

const CustomSelect: FC<CustomSelectProps> = ({ options, value, onChange, className, disabled }) => {
  const [open, setOpen] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [hoveredOption, setHoveredOption] = useState<string | null>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClick = () => {
    if (disabled) {
      toast.error("Please upgrade your plan to modify");
      return;
    }
    setOpen(!open);
  };

  return (
    <div ref={containerRef} className={`relative inline-block w-[150px] md:w-[200px] ${className}`}>
      <button
        onClick={handleClick}
        className={`w-full px-4 py-2 border border-black rounded-[25px] bg-transparent text-left ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        disabled={disabled}
      >
        {value || "Select time"}
      </button>
      <GoChevronDown className={`absolute right-3 top-[20px] transform -translate-y-1/2 pointer-events-none ${
        disabled ? 'opacity-50' : ''
      }`} />
      {open && !disabled && (
        <ul className="absolute z-10 w-full mt-1 border border-gray-400 rounded-[8px] bg-white max-h-[150px] overflow-y-auto side_bar">
          {options.map((option) => (
            <li
              key={option}
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
              onMouseEnter={() => setHoveredOption(option)}
              onMouseLeave={() => setHoveredOption(null)}
              className={`px-4 py-2 cursor-pointer ${
                option === "OFF" && hoveredOption === option
                  ? "bg-red-500 text-white"
                  : "hover:bg-gray-200"
              }`}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
